import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/groups.js';
import form from '../forms/groups.js';
import * as types from '../types.js';

const groups = function()
{

	let groups_crud = crud.create({
		async loadBaseData()
		{
			const [endpoints, companies] = await Promise.all([
				api.call(api.list_endpoints, this.queryAll()),
				api.call(api.list_all_companies, this.queryAll()),
			]);
			if (endpoints) await db.set('endpoints', endpoints).catch(e => notify(e));
			if (companies) await db.set('all_companies', companies).catch(e => notify(e));
		},
		async queryData(query)
		{
			return await api.call(api.list_groups, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_group, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				name: data.name,
				endpoints: data.endpoints,
				companies: data.companies,
			};
			if (old_data)
				return await api.call(api.update_group, data.id, _record);
			else
				return await api.call(api.insert_group, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'id', label: 'Grupo', types: [], placeholder: '', title: 'Identificador do grupo' },
		{ index: 2, field: 'name', label: 'Nome', types: [types.name()], placeholder: '', title: 'Nome do grupo' },
	];

	groups_crud.run(
		'groups',
		'Grupos',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default groups;

